/** Running log of what just happened. Newest at the bottom, like a table talk. */

import { useEffect, useRef } from 'react';
import type { SessionEvent } from '@lastroll/engine';

const REST_LABEL: Record<string, string> = { nightmare: '악몽', shallow: '얕은 잠', deep: '깊은 잠' };

/** 휴식 한 줄 머리 — 굴린 눈 · 잠의 깊이 · 회복 · 악몽의 빚. */
function RestLine({ data }: { data: SessionEvent['data'] }): JSX.Element {
  const face = Number(data?.['face'] ?? 0);
  const kind = String(data?.['kind'] ?? '');
  const healed = Number(data?.['healed'] ?? 0);
  const debt = Number(data?.['fateDebt'] ?? 0);
  return (
    <strong className="entry__head">
      휴식 · 🎲{face} {REST_LABEL[kind] ?? ''} · 체력 +{healed}
      {debt > 0 ? ` · 운명 빚 +${debt}` : ''}
    </strong>
  );
}

export function Feed({ events }: { events: readonly SessionEvent[] }): JSX.Element | null {
  const endRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }, [events.length]);

  const withText = events.filter((e) => e.text);
  if (withText.length === 0) return null;

  return (
    <div className="feed" role="log" aria-live="polite">
      {withText.slice(-8).map((e, i) => (
        <div key={`${e.kind}-${i}`} className={`entry entry--${e.kind}`}>
          {e.kind === 'rested' && <RestLine data={e.data} />}
          {e.text}
        </div>
      ))}
      <div ref={endRef} />
    </div>
  );
}
